export const DefaultConst = {
  REGEX_INTEGER: '^[0-9]*$',
  REGEX_NAME: '^([^0-9@#$%^&\\*]{1,64})$',
  REGEX_URL_HTTPS: '^(https)://(.*)',
  REWARD_BRANDS: ['Contigo'],
  PAGINATION_LIST: [10, 25, 50, 100],
  PER_PAGE: 8,
  TEXTAREA_ROWS: 4,
  FIELD_SMS_MAX_CHARACTERS: 400,
  FIELD_MESSAGE_MAX_CHARACTERS_TITLE: 65,
  FIELD_MESSAGE_MAX_CHARACTERS_BODY: 178,
  FIELD_MESSAGE_MAX_CHARACTERS_BODY_LONG: 255,
  FIELD_TEXT_MAX_CHARACTERS: 100,
  FIELD_TEXTAREA_MAX_CHARACTERS: 1024,
  CARD_FORMAT_DATE: 'MMM/dd/yy',
  BRAND_MEGAPOINT_NAME: 'Points',
  BRAND_BRAND_NAME: '',
  TABLE_X_SCROLL: '1100px',
  CUSTOM_FILTER_RESET: 'CUSTOM_FILTER_RESET',
  COPPEL_BRAND_ROLES_ACCESS: [
    // coppel exception
    {
      brandUuid: '0682fadc-93a2-431f-bb4b-d7714f207139',
      roleUuids: ['c3fdc2db-0015-4264-bf18-f9fc191f5eff'],
    },
  ],
  SISENSE_JWT_COOKIE_NAME: '_jwtToken',
};
